import { isFieldText } from '~/components/FieldText';
import { FieldType } from '~/shared/domain/models';
import { cnpjMask } from './masks/cnpj';
import { cpfMask } from './masks/cpf';
import { currencyMask } from './masks/currency';
import { dateMask } from './masks/date';
import { numberMask } from './masks/number';
import { phoneMask } from './masks/phone';
import { zipcodeMask } from './masks/zipcode';
import type { FieldsSchema } from '~/shared/domain/models';

export const generateFieldDefaultValue = (field: FieldsSchema, persistedValue?: any) => {
  if (persistedValue) {
    field.defaultValue = persistedValue;
  }

  if (!field.defaultValue) {
    return undefined;
  }

  if (!isFieldText(field)) {
    return field.defaultValue;
  }

  switch (field.type) {
    case FieldType.cnpj:
      return cnpjMask.maskDefault(field.defaultValue);
    case FieldType.cpf:
      return cpfMask.maskDefault(field.defaultValue);
    case FieldType.currency:
      return currencyMask.maskDefault(field.defaultValue);
    case FieldType.date:
      return dateMask.maskDefault(field.defaultValue);
    case FieldType.number:
      return numberMask.maskDefault(field.defaultValue);
    case FieldType.tel:
      return phoneMask.maskDefault(field.defaultValue);
    case FieldType.zipcode:
      return zipcodeMask.maskDefault(field.defaultValue);
    default:
      return field.defaultValue;
  }
};
